import { NoteBodyComponent } from './../template/note-body/note-body.component';
import { Type, ComponentRef } from '@angular/core';

export class WidgetListItem {

    constructor(
        public id: string,
        public name: string,
        public componentType: Type<any>,
        public maxCount: number,
        public componentInitializer: (ref: ComponentRef<any>, value?: any) => void,
        public templateConfiguration: any) {
    }
}

export class WidgetInstance {
    public componentReference: ComponentRef<any>;
    public selected = false;
    public height = 'auto';
    public widgetId: string;
    public deletable = true;

    constructor(
        public id: string,
        public componentType: Type<any>,
        public componentInitializer?: (instance: WidgetInstance) => void,
        public value?: any,
        public undeletableTitle?: string) {
        if (componentType === NoteBodyComponent) {
            this.height = 'auto';
        }
        if (undeletableTitle) {
            this.deletable = false;
        } else {
            this.deletable = true;
        }
    }
}

export class WidgetInstanceListFeedback {
    type: 'add' | 'delete' | 'refreshItem';
    payload: WidgetInstance;
}
